module.exports = __webpack_public_path__ + "media/correct_move.8f3764f2.mp3";